export default "__VITE_ASSET__DZOAUEWy__"